export default "__VITE_ASSET__xcHt03Dn__"